// extracted by mini-css-extract-plugin
export var hidden = "_tn-0";